import { useSearchParams, usePathname, useRouter } from "next/navigation";

// helpers

const useQueryParams = <T = { [key: string]: string | undefined }>(customParams = {}) => {
  const search = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const params = new URLSearchParams(search);
  const queryParams: Record<string, string> = { ...customParams };

  for (const [key, value] of params) {
    queryParams[key] = value;
  }

  const setQueryParams = (obj: Record<string, string>, shouldReplace = false) => {
    Object.keys(obj).forEach(key => {
      if (typeof obj[key] !== "undefined" && obj[key] !== null) {
        params.set(key, obj[key]);
      } else {
        params.delete(key);
      }
    });

    if (shouldReplace) {
      router.replace(`${pathname}?${params.toString()}`, { scroll: false });
    } else {
      router.push(`${pathname}?${params.toString()}`, { scroll: false });
    }
  };

  return [queryParams, setQueryParams] as [T, (obj: Record<string, unknown>, shouldReplace?: boolean) => void];
};


export default useQueryParams;
